module.exports = __webpack_public_path__ + "static/media/horn2.f80dff9c.mp3";